import React, { Suspense, useEffect } from 'react'
import {
  Grid,
  Card,
  CardContent,
  Box,
} from '@mui/material'

import {
  useGetEnergyOverviewDataQuery,
} from '../../../../api/energy-analysis/calculateEnergySavingsApiSlice';

const ConsumerGroupEnergyDistributionPieChart = React.lazy(() =>
  import('remote/ConsumerGroupEnergyDistributionPieChart').catch(() => ({
    default: () => <div>Failed to load</div>,
  }))
);

const ConsumptionCard = React.lazy(() =>
  import('remote/ConsumptionCard').catch(() => ({
    default: () => <div>Failed to load</div>,
  }))
);

const EnergyAssetDataGrid = React.lazy(() =>
  import('remote/EnergyAssetDataGrid').catch(() => ({
    default: () => <div>Failed to load</div>,
  }))
);

const NoEnergyGroupFoundCard = React.lazy(() =>
  import('remote/NoEnergyGroupFoundCard').catch(() => ({
    default: () => <div>Failed to load</div>,
  }))
);

const formatNumber = (number) => {
  return new Intl.NumberFormat('da-DK').format(number);
};

const EnergyOverviewTab = (props) => {
  const {
    selectedAccount,
    selectedEnergyGroup,
    timeRange,
    handleSEURowClick,
    setTimestampSummary
  } = props;

  const {
    data: energyOverviewDataResult,
    isLoading: isLoadingOverviewData,
    isFetching: isFetchingOverviewData,
    isError: isErrorOverviewData,
    error: errorOverviewData,
  } = useGetEnergyOverviewDataQuery(
    {
      accountId: selectedAccount?.AccountId,
      energyGroupId: selectedEnergyGroup?.energyGroupId,
      start: timeRange.start,
      end: timeRange.end
    },
    {
      skip: !selectedAccount?.AccountId || !selectedEnergyGroup?.energyGroupId || !timeRange.start || !timeRange.end,
    }
  );

  
  useEffect(() => {
    if (energyOverviewDataResult) {
      setTimestampSummary(energyOverviewDataResult.TimestampsSummary)
    }
  }, [energyOverviewDataResult]);

  if (!energyOverviewDataResult) return null;

  return (


    <Box>
      {energyOverviewDataResult && selectedEnergyGroup?.energyTreeNodes.length > 0 && (
        <Grid container spacing={2} sx={{ height: '100%' }}>

          <Grid item xs={12} sm={12} md={8} sx={{ height: '100%' }}>
            <Suspense fallback={
              <div>Loading...</div>
            }>
              <EnergyAssetDataGrid
                energyDataSummary={energyOverviewDataResult.EnergyDataSummary}
                distributionBoardSummary={energyOverviewDataResult.DistributionBoardsSummary}
                energyDistributionSummary={energyOverviewDataResult.EnergyDistributionSummary}
                formatNumber={formatNumber}
                handleSEURowClick={handleSEURowClick}
              />
            </Suspense>
          </Grid>

          <Grid item xs={12} sm={12} md={4} sx={{ height: '100%' }}>

            <Grid container spacing={2} sx={{ height: '100%' }}>

              <Grid item xs={12} md={12}>
                <Suspense fallback={
                  <div>Loading...</div>
                  }>
                  <ConsumptionCard energyDataSummary={energyOverviewDataResult.EnergyDataSummary} timeRange={timeRange} dataPoints={energyOverviewDataResult.EnergyData} />
                </Suspense>
              </Grid>

              <Grid item xs={12} md={12}>
                <Card variant='outlined' sx={{ p: 2, borderRadius: 2, height: '100%' }}>
                  <CardContent>
                    <Suspense fallback={
                      <div>Loading...</div>
                    }>
                      <ConsumerGroupEnergyDistributionPieChart
                        energyDistributionSummary={energyOverviewDataResult.EnergyDistributionSummary}
                      />
                    </Suspense>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Box>
  )
}

export default EnergyOverviewTab